import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import qs from "qs";
import VueCookie from "vue-cookie";

Vue.use(VueCookie);
Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.prototype.qs = qs;

export default {
    state: {
        userExists: false,
        customerId: "",
        subscriptionOrderToken: ""
    },
    mutations: {
        assignUserData: (state, payload) => {
            state.userExists = payload.valid
            state.customerId = payload.customer_id
            state.subscriptionOrderToken = payload.subscription_access_token
        }
    },
    getters: {},
    actions: {
        doubleCheckUser({commit}, CheckData) {
            return axios({
                cancelToken: getcancelToken(CheckData),
                method: "post",
                data: {
                    action: "search_subscription",
                    email: CheckData.email,
                    zip: CheckData.zip,
                    orderId: CheckData.orderId
                },
                headers: {"Content-Type": "application/x-www-form-urlencoded"},
            })
                .then(response => {
                    commit('assignUserData', response.data)
                    return response.data
                })
                .catch(error => {
                    console.error('Error:', error);
                    throw error;
                });
        }
    }
}
function getcancelToken(payload) {
    if (typeof payload != "undefined") {
        if (typeof payload.cancelToken != "undefined") {
            if (typeof payload.cancelToken.token != "undefined") {
                return payload.cancelToken.token;
            }
        }
    }
    return null;
}
